/**
 * Generates the URL for the image of a CS2 skin based on its skin ID.
 *
 * @param {string} skin_id - The unique identifier of the CS2 skin.
 * @returns {string} The URL of the image corresponding to the specified CS2 skin.
 */
export const generateSkinImage = (skin_id: string): string => {
  return `https://steamcommunity-a.akamaihd.net/economy/image/class/730/${skin_id}`;
};
